import { createContext, useContext } from "react";

import { Post } from "@/api/areas/types";

export type PostDetailContextType = {
  post: Post & { belongsToClient: boolean };
};

export const PostDetailContext = createContext<PostDetailContextType | null>(
  null
);

export const usePostDetailContext = () => {
  const ctx = useContext(PostDetailContext);
  if (!ctx)
    throw new Error(
      "usePostDetailContext must be used within PostDetailBoundary"
    );
  return ctx;
};
